// Generated static UI catalog. User-created content is intentionally not included.
module.exports = {
  "-d '{\"workflowName\": \"My Workflow\"}' \\": "-d '{\"workflowName\": \"Min workflow\"}' \\",
  "-H \"Content-Type: application/json\" \\": "-H \"Content-Type: application/json\" \\",
  "\u2014 keep current snapshot \u2014": "\u2014 behold det aktuelle \u00f8jebliksbillede \u2014",
  "\u2014 needs your answer": "- har brug for dit svar",
  "\u2014 select \u2014": "\u2014 v\u00e6lg \u2014",
  "\u2014 select a workflow \u2014": "\u2014 v\u00e6lg en workflow \u2014",
  "\u2014 Select a workflow \u2014": "\u2014 V\u00e6lg en workflow \u2014",
  ". Publishing submits": ". Udgivelse indsender",
  ". Your current v": ". Din nuv\u00e6rende v",
  ". Your unsaved edits are based on an older version.": ". Dine ikke-gemte redigeringer er baseret p\u00e5 en \u00e6ldre version.",
  "\u00b7 autosaves on Save": "\u00b7 gemmer automatisk p\u00e5 Gem",
  "\u00b7 Free": "\u00b7 Gratis",
  "\u00b7 live v": "\u00b7 live v",
  "\u00b7 published": "\u00b7 offentliggjort",
  "(live: v": "(live: v",
  "(no details)": "(ingen detaljer)",
  "(open in a new tab if you want to connect a different account)": "(\u00e5bn i en ny fane, hvis du vil tilknytte en anden konto)",
  "(optional)": "(valgfrit)",
  "(output)": "(output)",
  "(pick to replace the saved snapshot)": "(v\u00e6lg for at erstatte det gemte snapshot)",
  "(required)": "(p\u00e5kr\u00e6vet)",
  "(screenshot)": "(sk\u00e6rmbillede)",
  ") was sent for review. A super admin will approve it before it goes live": ") blev sendt til gennemgang. En superadministrator vil godkende det, f\u00f8r det g\u00e5r live",
  "@ Use variable": "@ Brug variabel",
  "@var": "@var",
  "\u2190 Back": "\u2190 Tilbage",
  "\u2190 Dashboard": "\u2190 Dashboard",
  "\u2190 Exit admin": "\u2190 Afslut admin",
  "\u2190 Home": "\u2190 Hjem",
  "\u2190 Template store": "\u2190 Skabelonbutik",
  "\u2190 Til forsiden": "\u2190 Til forsiden",
  "\u2190 Tilbage": "\u2190 Tilbage",
  "+ Add": "+ Tilf\u00f8j",
  "\uff0b Add AI pointer step": "\uff0b Tilf\u00f8j AI-pegetrin",
  "+ Add condition": "+ Tilf\u00f8j betingelse",
  "+ Add Field": "+ Tilf\u00f8j felt",
  "+ Add group": "+ Tilf\u00f8j gruppe",
  "+ Add item": "+ Tilf\u00f8j element",
  "+ Add label": "+ Tilf\u00f8j etiket",
  "+ Add route": "+ Tilf\u00f8j rute",
  "\uff0b Add scroll step": "\uff0b Tilf\u00f8j rulletrin",
  "+ Add tag": "+ Tilf\u00f8j tag",
  "+ Add tags": "+ Tilf\u00f8j tags",
  "+ Add Variable": "+ Tilf\u00f8j variabel",
  "+ Connect another": "+ Tilslut en anden",
  "\uff0b Resume adding steps": "\uff0b Genoptag tilf\u00f8jelse af trin",
  "+ UI Page": "+ UI-side",
  "> \u00b7 refine just this (saves tokens)": "> \u00b7 forfine netop dette (gemmer tokens)",
  "\u23fa Record steps": "\u23fa Optag trin",
  "\u2605 Featured": "\u2605 Udvalgte",
  "\u2699\ufe0f Probe Results (click to expand)": "\u2699\ufe0f Proberesultater (klik for at udvide)",
  "\u26a0 Paused \u2014 click to resume": "\u26a0 Pause \u2013 klik for at genoptage",
  "\u2713 Changes applied": "\u2713 \u00c6ndringer anvendt",
  "\u2713 Run QA test": "\u2713 K\u00f8r QA-test",
  "\u2728 Let AI fill": "\u2728 Lad AI fylde",
  "\u29f8\u29f9 Last result": "\u29f8\u29f9 Sidste resultat",
  "\u29f8\u29f9 OUTPUT": "\u29f8\u29f9 OUTPUT",
  "1 min ago": "1 min siden",
  "1. Opret et nyt workflow": "1. Opret et nyt workflow",
  "2. Tiloj en Start-knude": "2. Tiloj en Start-knude",
  "3. Tiloj og forbind knuder": "3. Tiloj og forbind knuder",
  "4. Konfigurer knuderne": "4. Konfigurer knuderne",
  "5. Kor workflowet": "5. Kor workflowet",
  "A request is still streaming. Closing will cancel it.": "En anmodning streames stadig. Lukning vil annullere den.",
  "A\u2013Z": "A\u2013Z",
  "ABCD-2345": "ABCD-2345",
  "Abn dashboardet og klik \"+ Nyt workflow\". Giv det et sigende navn \u2014 du kan altid aendre det senere.": "Abn dashboardet og klik \"+ Nyt workflow\". Giv det et sigende navn \u2014 du kan altid aendre det senere.",
  "account connected.": "konto tilsluttet.",
  "Account name": "Kontonavn",
  "account removed.": "konto fjernet.",
  "Account settings": "Kontoindstillinger",
  "account to continue \u2014 then I\u2019ll re-check and keep going.": "konto for at forts\u00e6tte - s\u00e5 tjekker jeg igen og forts\u00e6tter.",
  "account. Connect another to enable per-node selection.": "konto. Tilslut en anden for at aktivere per-knude-valg.",
  "Accounts": "Konti",
  "accounts connected yet.": "konti tilsluttet endnu.",
  "Action failed.": "Handlingen mislykkedes.",
  "Actions": "Handlinger",
  "Active": "Aktiv",
  "Actor": "Skuespiller",
  "Add": "Tilf\u00f8j",
  "Add & use": "Tilf\u00f8j og brug",
  "Add a tool node": "Tilf\u00f8j en v\u00e6rkt\u00f8jsknude",
  "Add account": "Tilf\u00f8j konto",
  "Add AI Instruction": "Tilf\u00f8j AI-instruktion",
  "Add an email address to enable email notifications.": "Tilf\u00f8j en e-mailadresse for at aktivere e-mailmeddelelser.",
  "Add an existing tag or create a new one below.": "Tilf\u00f8j et eksisterende tag eller opret et nyt nedenfor.",
  "Add at least one workflow to this playbook before designing a UI page.": "Tilf\u00f8j mindst \u00e9n workflow til denne afspilningsbog, f\u00f8r du designer en UI-side.",
  "Add field": "Tilf\u00f8j felt",
  "Add image": "Tilf\u00f8j billede",
  "Add item": "Tilf\u00f8j element",
  "Add label...": "Tilf\u00f8j etiket...",
  "Add node": "Tilf\u00f8j knude",
  "Add Node": "Tilf\u00f8j knude",
  "Add param": "Tilf\u00f8j param",
  "Add response field": "Tilf\u00f8j svarfelt",
  "Add task instructions and optional workflow variables or node outputs for": "Tilf\u00f8j opgaveinstruktioner og valgfri workflowvariabler eller nodeoutput for",
  "Add variable": "Tilf\u00f8j variabel",
  "Add variable or output": "Tilf\u00f8j variabel eller output",
  "Add workflow-wide guidance and structured knowledge that AI nodes can reuse.": "Tilf\u00f8j workflow-d\u00e6kkende vejledning og struktureret viden, som AI-knuder kan genbruge.",
  "Add your API key above \u2014 it is required to run the actor.": "Tilf\u00f8j din API-n\u00f8gle ovenfor - det er n\u00f8dvendigt for at k\u00f8re skuespilleren.",
  "Additional Context": "Yderligere kontekst",
  "Additional Instructions": "Yderligere instruktioner",
  "Admin": "Admin",
  "Advanced": "Avanceret",
  "after \"": "efter \"",
  "After completion": "Efter afslutning",
  "Agent node": "Agent knude",
  "AI": "AI",
  "AI agent": "AI agent",
  "AI Assistant": "AI assistent",
  "AI fill failed.": "AI-fyldning mislykkedes.",
  "AI Flow Builder": "AI Flow Builder",
  "AI Instruction": "AI instruktion",
  "AI Memory": "AI hukommelse",
  "AI Settings": "AI-indstillinger",
  "AI-klassificering": "AI-klassificering",
  "AI-kredit": "AI-kredit",
  "AI-kreditter bruges til generering, k\u00f8rsel, fixing og planl\u00e6gning. Forbruget afh\u00e6nger af den valgte model \u2014 capable (h\u00f8jere kvalitet) eller standard (hurtigere, billigere).": "AI-kreditter bruges til generering, k\u00f8rsel, fixing og planl\u00e6gning. Forbruget afh\u00e6nger af den valgte model \u2014 capable (h\u00f8jere kvalitet) eller standard (hurtigere, billigere).",
  "aiPointer": "aiPointer",
  "Aktiv plan": "Aktiv plan",
  "All": "Alle",
  "All AI nodes": "Alle AI-knuder",
  "All fields are required.": "Alle felter er obligatoriske.",
  "All request and response bodies use JSON. Set the Content-Type header to application/json for POST/PUT requests.": "Alle anmodnings- og svarinstanser bruger JSON. Indstil Content-Type-overskriften til application/json for POST/PUT-anmodninger.",
  "Alleflow": "Alleflow",
  "AlleFlow": "AlleFlow",
  "AlleFlow \u2014 komplet dokumentation": "AlleFlow \u2014 komplet dokumentation",
  "Alleflow is ready in Chrome": "Alleflow er klar i Chrome",
  "Alleflow user": "Alleflow bruger",
  "Already connected \u2014 retry": "Allerede forbundet \u2014 pr\u00f8v igen",
  "Alt du behoever for at bygge, kore og automatisere workflows. Fra grundlaeggende knude-typer til avanceret AI-klassificering, planlaegning og API-integration.": "Alt du behoever for at bygge, kore og automatisere workflows. Fra grundlaeggende knude-typer til avanceret AI-klassificering, planlaegning og API-integration.",
  "An account name is required.": "Et kontonavn er p\u00e5kr\u00e6vet.",
  "An unexpected error occurred.": "Der opstod en uventet fejl.",
  "Analyser og fix": "Analyser og fix",
  "Analysis complete.": "Analyse f\u00e6rdig.",
  "Analyzing workflow...": "Analyserer workflow...",
  "AND": "OG",
  "Angiv kommaseparerede labels, f.eks. \"positiv,negativ,neutral\". Hver label far sin egen udgaende forbindelse. Max 20 labels.": "Angiv kommaseparerede labels, f.eks. \"positiv,negativ,neutral\". Hver label far sin egen udgaende forbindelse. Max 20 labels.",
  "Any feedback?": "Nogen feedback?",
  "API docs": "API-dokumenter",
  "API Docs": "API-dokumenter",
  "API key": "API n\u00f8gle",
  "API Keys": "API n\u00f8gler",
  "Apify": "Apify",
  "Apify API key": "Apify API-n\u00f8gle",
  "Apify console": "Apify konsol",
  "apify_api_\u2026": "apify_api_...",
  "Append": "Tilf\u00f8j",
  "Applied": "Anvendt",
  "Applied to every AI node in this workflow.": "Anvendt p\u00e5 hver AI-knude i denne workflow.",
  "Apply failed": "Anvendelse mislykkedes",
  "Apply Fix": "Anvend Fix",
  "Applying fix from Workflow Doctor\u2026": "Anvender rettelse fra Workflow Doctor...",
  "Approve": "Godkend",
  "Approve all": "Godkend alle",
  "Approve Chrome device": "Godkend Chrome-enhed",
  "Approve device": "Godkend enhed",
  "Approve on Apify \u2197": "Godkend p\u00e5 Apify \u2197",
  "Approve the permissions": "Godkend tilladelserne",
  "Approve this Chrome extension?": "Vil du godkende denne Chrome-udvidelse?",
  "Approve this extension?": "Vil du godkende denne udvidelse?",
  "Approved": "Godkendt",
  "Approved \u2014 applying": "Godkendt \u2014 ans\u00f8ger",
  "Approving as": "Godkender som",
  "Approving\u2026": "Godkender...",
  "Array": "Array",
  "Ask": "Sp\u00f8rg",
  "Ask a question or describe a change \u2014 e.g. \"What does this do?\" or \"Only show active products\"": "Stil et sp\u00f8rgsm\u00e5l eller beskriv en \u00e6ndring \u2014 f.eks. \"Hvad g\u00f8r det her?\" eller \"Vis kun aktive produkter\"",
  "Ask about the log\u2026": "Sp\u00f8rg om loggen...",
  "Ask about this step": "Sp\u00f8rg om dette trin",
  "Ask anything about your workflow. I can find broken nodes, explain logic, and propose a fix plan.": "Sp\u00f8rg hvad som helst om din workflow. Jeg kan finde kn\u00e6kkede knuder, forklare logik og foresl\u00e5 en l\u00f8sningsplan.",
  "Ask Copilot to explore or edit your workflow\u2026": "Bed Copilot om at udforske eller redigere din workflow...",
  "Ask for changes to existing variables or nodes before building.": "Bed om \u00e6ndringer til eksisterende variabler eller knuder, f\u00f8r du bygger.",
  "Ask me anything about the last workflow run \u2014 timings, errors, or how to improve it.": "Sp\u00f8rg mig om noget om den sidste arbejdsgangk\u00f8rsel - timings, fejl eller hvordan man forbedrer den.",
  "Ask me to change this workflow \u2014 rename nodes, rewire connections, tweak params, add branches\u2026": "Bed mig om at \u00e6ndre denne workflow - omd\u00f8b knuder, omforbind forbindelser, tweak parametre, tilf\u00f8j filialer...",
  "Ask your AI Agents": "Sp\u00f8rg dine AI-agenter",
  "AskCode handler not wired by parent.": "AskCode-handleren er ikke forbundet med for\u00e6lderen.",
  "At run time the AI scans the page\u2019s clickable elements and moves the virtual mouse onto the best match. It does not click.": "P\u00e5 k\u00f8retid scanner AI sidens klikbare elementer og flytter den virtuelle mus til det bedste match. Den klikker ikke.",
  "Atlassian": "Atlassian",
  "Attach crop": "Vedh\u00e6ft afgr\u00f8de",
  "Attach full snapshot": "Vedh\u00e6ft hele snapshot",
  "Attach image": "Vedh\u00e6ft billede",
  "attached preview snapshot": "vedh\u00e6ftede forh\u00e5ndsvisningsbillede",
  "attached screenshot": "vedh\u00e6ftede sk\u00e6rmbillede",
  "Autentificering": "Autentificering",
  "Authentication": "Autentificering",
  "Authentication failed.": "Godkendelse mislykkedes.",
  "Author": "Forfatter",
  "Authorization code": "Autorisationskode",
  "Auto \u2014 use the last used tab": "Auto - brug den senest brugte fane",
  "Automatically learned from your previous workflows. Read-only.": "L\u00e6rer automatisk fra dine tidligere workflows. Skrivebeskyttet.",
  "Autopilot": "Autopilot",
  "Autopilot flagged this step": "Autopiloten har markeret dette trin",
  "Autopilot is fixing this node\u2026": "Autopiloten retter denne knude...",
  "Available Variables": "Tilg\u00e6ngelige variabler",
  "Avanceret tilstand": "Avanceret tilstand",
  "Back": "Tilbage",
  "Back to fields": "Tilbage til felterne",
  "Back to workflows": "Tilbage til workflows",
  "Balanced": "Balanceret",
  "Balanced \u2014 best cost/quality": "Balanceret \u2014 bedste pris/kvalitet",
  "Base URL": "Basis URL",
  "Be specific \u2014 the AI uses this to wire inputs and outputs.": "V\u00e6r specifik - AI'en bruger dette til at forbinde input og output.",
  "Before you run it": "F\u00f8r du k\u00f8rer det",
  "Begynd at bygge gratis": "Begynd at bygge gratis",
  "Being read by running node": "Bliver l\u00e6st ved at k\u00f8re knude",
  "Beta": "Beta",
  "Beta waitlist": "Beta venteliste",
  "Betingelser": "Betingelser",
  "Blush": "R\u00f8dme",
  "Body parameters": "Kropsparametre",
  "Boolean": "Boolean",
  "Border color": "Kantfarve",
  "Border Color": "Kantfarve",
  "Bottom-left of the warning screen.": "Nederst til venstre p\u00e5 advarselssk\u00e6rmen.",
  "Bronze": "Bronze",
  "Browser Action": "Browserhandling",
  "Browser Action extension not connected. Load browser_action_ext in Chrome (chrome://extensions) and keep Chrome open.": "Browser Action-udvidelsen er ikke forbundet. Indl\u00e6s browser_action_ext i Chrome (chrome://extensions), og hold Chrome \u00e5ben.",
  "Browser Action extension not connected. Load it in Chrome and keep Chrome open.": "Browser Action-udvidelsen er ikke forbundet. Indl\u00e6s den i Chrome, og hold Chrome \u00e5ben.",
  "Browser Agentic Action": "Browseragenthandling",
  "Browser Engine": "Browser Engine",
  "Browser Run": "Browser K\u00f8r",
  "Browser tab": "Browser fane",
  "Browser workflows": "Browser workflows",
  "Browser workflows aren\u2019t listed \u2014 they run in your Chrome and can\u2019t be scheduled.": "Browser-workflows er ikke angivet - de k\u00f8rer i din Chrome og kan ikke planl\u00e6gges.",
  "Brug @-syntaks i parametre": "Brug @-syntaks i parametre",
  "Brug en API-nogle i headeren: X-API-Key: din_nogle. Opret nogler fra API Keys-siden i dashboardet.": "Brug en API-nogle i headeren: X-API-Key: din_nogle. Opret nogler fra API Keys-siden i dashboardet.",
  "Brug planneren til at bygge agentic workflows automatisk.": "Brug planneren til at bygge agentiske workflows automatisk.",
  "Brugere udfylder formularen": "Brugere udfylder formularen",
  "Brugt af teams der bygger med moderne v\u00e6rkt\u00f8jer": "Brugt af teams der bygger med moderne v\u00e6rkt\u00f8jer",
  "Bug": "Bug"
};
